import { isBrowser } from "../utils/index";

const name = "addToCart";

export type AddToCartItem = {
  id: string;
  price: number;
  name: string;
  category: string;
  quantity: number;
  // Shopify Analytics fields
  productGid: string;
  variantGid: string;
  variantName: string;
};

export type AddToCartEvent = {
  items: AddToCartItem[];
  value: number;
  currency: string;
  // Shopify Analytics: cart ID
  cartId: string;
};

const addToCart = (detail: AddToCartEvent) => {
  if (!isBrowser) return;

  const event = new CustomEvent<AddToCartEvent>(name, { detail });

  console.info(`🎯 → %c${event.type}`, "font-style: italic", event.detail);

  window.dispatchEvent(event);
};

export const register = (fn: (e: CustomEvent<AddToCartEvent>) => void) => {
  window.addEventListener(name, fn as EventListener, { passive: true });
  // Return cleanup function
  return () => window.removeEventListener(name, fn as EventListener);
};
export default addToCart;
